import { createApp, defineCustomElement } from 'vue'
import App from './App.vue'

import {
	FancyBox,
	BreakingMedFeed,
	CognitiveSearch,
	IhpBanner,
	IraeSearch,
	Accordion,
	PreTest,
	PostTest,
	SinglePostTest,
	MultiPostTest,
	MultiPreTest,
	PollingQuestion,
	CMEInformation,
	UniversalChatbot,
  LinkedInTracker,
  Auth,
  Completionist
} from './views/'

const FancyBoxElement = defineCustomElement(FancyBox)
const BreakingMedFeedElement = defineCustomElement(BreakingMedFeed)
const IraeSearchElement = defineCustomElement(IraeSearch)
const CognitiveSearchElement = defineCustomElement(CognitiveSearch)
const IhpBannerElement = defineCustomElement(IhpBanner)
const AccordionElement = defineCustomElement(Accordion)
const PreTestElement = defineCustomElement(PreTest)
const PostTestElement = defineCustomElement(PostTest)
const SinglePostTestElement = defineCustomElement(SinglePostTest)
const MultiPostTestElement = defineCustomElement(MultiPostTest)
const MultiPreTestElement = defineCustomElement(MultiPreTest)
const PollingQuestionElement = defineCustomElement(PollingQuestion)
const CMEInformationElement = defineCustomElement(CMEInformation)
const UniversalChatbotElement = defineCustomElement(UniversalChatbot)
const LinkedInTrackerElement = defineCustomElement(LinkedInTracker)
const AuthElement = defineCustomElement(Auth)
const CompletionistElement = defineCustomElement(Completionist)

customElements.define('fancy-box', FancyBoxElement)
customElements.define('breakingmed-feed', BreakingMedFeedElement)
customElements.define('irae-search', IraeSearchElement)
customElements.define('cognitive-search', CognitiveSearchElement)
customElements.define('ihp-banner', IhpBannerElement)
customElements.define('pik-accordion', AccordionElement)
customElements.define('pik-pretest', PreTestElement)
customElements.define('pik-posttest', PostTestElement)
customElements.define('pik-single-posttest', SinglePostTestElement)
customElements.define('pik-multi-posttest', MultiPostTestElement)
customElements.define('pik-multi-pretest', MultiPreTestElement)
customElements.define('polling-question', PollingQuestionElement)
customElements.define('cme-information', CMEInformationElement)
customElements.define('universal-chatbot', UniversalChatbotElement)
customElements.define('linkedin-tracker', LinkedInTrackerElement)
customElements.define('pik-auth', AuthElement)
customElements.define('pik-completionist', CompletionistElement)

createApp(App)
	.mount('#widget-getter-demo')